import { camelizeKeys } from 'humps';
import isEmpty from 'lodash/isEmpty';
import createError from 'http-errors';

export function fetchWithJson(url, opts = {credentials: 'same-origin'}) {
  return fetch(`${url}`, opts).then(response => {
    return response.text().then(body => {
      if (response.status === 200) {
        return camelizeKeys(JSON.parse(body));
      } else if (response.status === 400 && !isEmpty(body)) {
        throw createError(response.status, '', JSON.parse(body));
      } else {
        throw createError(response.status);
      }
    });
  });
}

export function fetchWithJsonNoCamel(url, opts = {credentials: 'same-origin'}) {
  return fetch(`${url}`, opts).then(response => {
    return response.text().then(body => {
      if (response.status === 200) {
        return JSON.parse(body);
      } else if (response.status === 400 && !isEmpty(body)) {
        throw createError(response.status, '', JSON.parse(body));
      } else {
        throw createError(response.status);
      }
    });
  });
}




// WEBPACK FOOTER //
// ./src/utils/api.js